import Button from '@components/button/Button';
import Icon from '@components/icon/Icon';
import { getWalkthroughDetails, WalkthroughItem } from '@constants/generic';
import Modal from '@layouts/modal/Modal';

interface WalkthroughProps {
  // handleSkip: () => void;
  currentHint: WalkthroughItem;
  handlePrimaryAction: () => void;
  userName: string;
  isLoading: boolean;
}

const WalkThroughModal = ({
  currentHint,
  handlePrimaryAction,
  // handleSkip,
  userName,
  isLoading
}: WalkthroughProps) => {
  const { title, description, image, buttonLabel, subDescription } =
    getWalkthroughDetails(currentHint, userName);

  return (
    <Modal isOpen>
      <div className="flex w-105 max-w-500 flex-col items-center p-6 text-center">
        <div className="text-lg font-medium">{title}</div>

        <Icon name={image || ''} size="none" className="my-3" />

        <p className="text-sm text-grey">{description}</p>
        {subDescription && (
          <p className="text-sm text-grey">{subDescription}</p>
        )}

        <div className="mt-6 flex w-full flex-col items-center justify-center gap-2">
          <Button
            variant="primary"
            label={buttonLabel}
            handleClick={handlePrimaryAction}
            className="!h-11"
            size="small"
            loading={isLoading}
          />
          {/* <div
            className="cursor-pointer text-base text-grey"
            role="presentation"
            onClick={handleSkip}
          >
            Skip
          </div> */}
        </div>
      </div>
    </Modal>
  );
};

export default WalkThroughModal;
